export const NETWORK_STATUS_EVENT = "app:network-status-change";

export const NETWORK_STATUS = {
    ONLINE: "online",
    OFFLINE: "offline",
    SERVER_DOWN: "server_down",
};

export const emitNetworkStatus = (status) => {
    window.dispatchEvent(new CustomEvent(NETWORK_STATUS_EVENT, { detail: { status } }));
};
